import { wrapProperty } from '@nuxtjs/composition-api'
export default wrapProperty('$message', false)

